import EnclosureHttp from '@/utils/http'
import { HttpConfig } from '@/utils/http/types'
import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { isFunction } from 'lodash'

const CHATBOT_BASE_URL = '/chatbot-api'

const http = new EnclosureHttp({
  baseUrl: CHATBOT_BASE_URL
})

export default function chatbotRequest<
  T = any,
  D = any,
  R = any,
>(
  config: AxiosRequestConfig<D> & {
    requestConfig?: HttpConfig<T, D, AxiosResponse<R, D>>
  },
): Promise<R> {
  const instance = http.request<T, D, AxiosResponse<R, D>>({
    ...config,
    requestConfig: {
      ...config.requestConfig,
      message: false,
    },
  })
  return instance
    .then(res => res?.data)
    .catch(error => {
      const responseData = error?.response?.data
      if (responseData && typeof responseData === 'object' && 'code' in responseData) {
        return responseData as R
      }
      return Promise.reject(error)
    }) as Promise<R>
}
